//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { swiper, swiperSlide } from "vue-awesome-swiper";

import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    handleVideo(index) {
      this.$emit("modalClick", true, index);
    },
    bannerChange() {
      let index = this.aIndex;
      this.bannerImgList = [];
      this.$nextTick(() => {
        this.bannerImgList = this.bannerList;
        this.$nextTick(() => {
          this.$refs.swiperTop.swiper.slideTo(index, 100);
          this.$refs.swiperTop.swiper.update(true);
        });
      });
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      isMobile: (state) => state.app.isMobile,
      lang: (state) => state.app.lang,
    }),
  },
  watch: {
    // isMobile(v) {
    //   this.bannerChange();
    // },
    lang(v) {
      this.bannerChange();
    },
  },
  mounted() {
    this.bannerChange();
  },
  updated() {
    // this.bannerChange();
  },
  data() {
    return {
      aIndex: 1,
      changeDir: "image",
      bannerImgList: [],
      bannerList: [
        {
          picUrl: require("@/assets/static/image/1.jpg"),
          title: "banner.baijiale",
          smallTitle: "bannerSmallTitle.baijiale",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/2.jpg"),
          title: "banner.lunpan",
          smallTitle: "bannerSmallTitle.lunpan",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/3.jpg"),
          title: "banner.buyu",
          smallTitle: "bannerSmallTitle.buyu",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/4.jpg"),
          title: "banner.zhanjinhua",
          smallTitle: "bannerSmallTitle.zhanjinhua",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/5.jpg"),
          title: "banner.niuniu",
          smallTitle: "bannerSmallTitle.niuniu",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/6.jpg"),
          title: "banner.tuiTongzi",
          smallTitle: "bannerSmallTitle.tuiTongzi",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/7.jpg"),
          title: "banner.longhu",
          smallTitle: "bannerSmallTitle.longhu",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/8.jpg"),
          title: "banner.dezhou",
          smallTitle: "bannerSmallTitle.dezhou",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/9.jpg"),
          title: "banner.jisuhua",
          smallTitle: "bannerSmallTitle.jisuhua",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/10.jpg"),
          title: "banner.shisanshui",
          smallTitle: "bannerSmallTitle.shisanshui",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/12.jpg"),
          title: "banner.paijiu",
          smallTitle: "bannerSmallTitle.paijiu",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/14.jpg"),
          title: "banner.kingOfFishing3D",
          smallTitle: "bannerSmallTitle.kingOfFishing3D",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/15.jpg"),
          title: "banner.ershiyidian",
          smallTitle: "bannerSmallTitle.ershiyidian",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/17.jpg"),
          title: "banner.bairenbaijiale",
          smallTitle: "bannerSmallTitle.bairenbaijiale",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/18.jpg"),
          title: "banner.honghei",
          smallTitle: "bannerSmallTitle.honghei",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/21.jpg"),
          title: "banner.shidianban",
          smallTitle: "bannerSmallTitle.shidianban",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/19.jpg"),
          title: "banner.niuniu4",
          smallTitle: "bannerSmallTitle.niuniu4",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/20.jpg"),
          title: "banner.bairenniuniu",
          smallTitle: "bannerSmallTitle.bairenniuniu",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/24.jpg"),
          title: "banner.majiangxueliu",
          smallTitle: "bannerSmallTitle.majiangxueliu",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/23.jpg"),
          title: "banner.benzAndBMW",
          smallTitle: "bannerSmallTitle.benzAndBMW",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/29.png"),
          title: "banner.fanbeimajiang",
          smallTitle: "bannerSmallTitle.fanbeimajiang",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/pirateFishing.png"),
          title: "banner.pirateFishing",
          smallTitle: "bannerSmallTitle.pirateFishing",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/mermaidFishing.png"),
          title: "banner.mermaidFishing",
          smallTitle: "bannerSmallTitle.mermaidFishing",
          flag: 0,
          right: true,
        },
        {
          picUrl: require("@/assets/static/image/dzpk_qzc_banner.png"),
          title: "banner.dezhou_qz",
          smallTitle: "bannerSmallTitle.dezhou_qz",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/errenmj_banner.png"),
          title: "banner.errenmj",
          smallTitle: "bannerSmallTitle.errenmj",
          flag: 0,
          right: true,
        },
        {
          picUrl: require("@/assets/static/image/ksznn_3d_banner.png"),
          title: "banner.ksznn_3d",
          smallTitle: "bannerSmallTitle.ksznn_3d",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/qznn_3d_banner.png"),
          title: "banner.qznn_3d",
          smallTitle: "bannerSmallTitle.qznn_3d",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/doudizhujishu.png"),
          title: "banner.ddzjs",
          smallTitle: "bannerSmallTitle.ddzjs",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/banner_1027.png"),
          title: "banner.jokerNiuniu",
          smallTitle: "bannerSmallTitle.jokerNiuniu",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/1048.png"),
          title: "banner.lkpy",
          smallTitle: "bannerSmallTitle.lkpy",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/1049.png"),
          title: "banner.dntg",
          smallTitle: "bannerSmallTitle.dntg",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/1404.png"),
          title: "banner.goldenCountry",
          smallTitle: "bannerSmallTitle.goldenCountry",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/1050.png"),
          title: "banner.birdingJoy",
          smallTitle: "bannerSmallTitle.birdingJoy",
          flag: 0,
        },
        {
          picUrl: require("@/assets/static/image/25.jpg"),
          title: "banner.forestParty",
          smallTitle: "bannerSmallTitle.forestParty",
          flag: 13,
        },
        {
          picUrl: require("@/assets/static/image/26.jpg"),
          title: "banner.majiangxuezhan",
          smallTitle: "bannerSmallTitle.majiangxuezhan",
          flag: 13,
        },
        {
          picUrl: require("@/assets/static/image/27.jpg"),
          title: "banner.landlord",
          smallTitle: "bannerSmallTitle.landlord",
          flag: 13,
        },
        {
          picUrl: require("@/assets/static/image/28.jpg"),
          title: "banner.jinsaPoker",
          smallTitle: "bannerSmallTitle.jinsaPoker",
          flag: 13,
        },
      ],
      swiperOptionTop: {
        // spaceBetween: 8,
        // spaceBetween: 30,
        observer: true,
        observeParents: true,
        loop: true,
        //loopAdditionalSlides: 3,
        // swiperSlides: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        // loopFillGroupWithBlank: true,
        centeredSlides: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-self",
          prevEl: ".swiper-button-prev-self",
        },
        //paginationClickable: true,
        autoplayDisableOnInteraction: false,
        // pagination: {
        //     //   el: ".swiper-pagination",
        //     el: ".pic-btn",
        //     //   type: "custom",
        //     clickable: true,
        //     paginationType: "custom"
        // },
        on: {
          slideChange: function () {
            this.aIndex = this.$refs.swiperTop.swiper
              ? this.$refs.swiperTop.swiper.activeIndex
              : 1;
            // console.log(this.$refs.swiperTop.swiper, 741, this.aIndex);
          }.bind(this),
        },
        // debugger: true
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Thumbnail/index.vue